import { Controller } from "@hotwired/stimulus";
import "../../shared/cally";

export default class extends Controller {
  static targets = ["calendar"];
  static values = {
    disabledDates: Array,
  };

  connect() {
    this.setupCalendar();
  }

  setupCalendar() {
    if (!this.hasCalendarTarget) return;

    const disabledSet = new Set(this.disabledDatesValue);

    this.calendarTarget.isDateDisallowed = (date) => {
      const dateStr = date.toISOString().split("T")[0];
      return disabledSet.has(dateStr);
    };
  }

  dateChanged(event) {
    const newDate = event.target.value;
    if (!newDate) return;

    const url = new URL(window.location.href);
    url.searchParams.set("date", newDate);

    Turbo.visit(url.toString(), { action: "replace" });
  }
}
